import { useSuspenseQuery } from '@tanstack/react-query';
import FareDoneCard from '../components/FareDoneCard';
import FareListContainer from '../components/FareListContainer';
import { getDailyFaresQueryOptions } from '../queries';

const DoneFaresPage = () => {
  const { data: doneFares } = useSuspenseQuery(getDailyFaresQueryOptions());

  return <FareListContainer>{doneFares?.map((fare) => <FareDoneCard key={fare.id} fare={fare} />)}</FareListContainer>;
};

export default DoneFaresPage;
